/**
 * Renders a regular boost (reblog) feed item — header + embedded PostCard.
 * Translations are their own posts, rendered by TranslationCard instead.
 */
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Repeat2 } from 'lucide-react'
import type { Boost, Post, EventPost, OfferPost } from '@olimhub/shared'
import { PostCard } from './PostCard'
import { PostBadge } from './PostBadge'

interface BoostCardProps {
  boost: Boost
  readOnly?: boolean
  onBoost?: (id: string) => void
  onReport?: (id: string) => void
}

export function BoostCard({ boost, readOnly, onBoost, onReport }: BoostCardProps) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div>
      <div
        style={{
          padding: '10px 16px 0',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <Repeat2 size={16} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
        <button
          type="button"
          onClick={() => navigate(`/@${boost.account.username}`)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--fs-xs)',
            fontWeight: 600,
            color: 'var(--text-muted)',
            textAlign: 'start',
          }}
        >
          {t('post.boosted_by_user', { username: boost.account.username })}
        </button>
        <PostBadge badges={boost.account.badges} />
      </div>
      <PostCard
        post={boost.originalPost as Post | EventPost | OfferPost}
        readOnly={readOnly}
        isNested
        onBoost={onBoost}
        onReport={onReport}
      />
    </div>
  )
}
